import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/accommodation.css";

import AccommodationImg1 from "../assets/room/villa/villa1.jpg";
import AccommodationImg2 from "../assets/room/luxury-cottage/luxury-cottage1.jpg";
import AccommodationImg3 from "../assets/room/wooden-cottage/wooden-cottage1.jpg";

const Accommodation = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/explore-rooms");
  };

  return (
    <section className="accommodation-section">
      <h1>Accommodation</h1>
      <div className="accommodation-container">
        {[ 
          { img: AccommodationImg1, title: "Villa" },
          { img: AccommodationImg2, title: "Luxury Cottage" },
          { img: AccommodationImg3, title: "Wooden Cottage" }
        ].map((item, index) => (
          <div className="accommodation-card" key={index}>
            <img src={item.img} alt={item.title} />
            <div className="accommodation-card-content">
              <h4>{item.title}</h4>
              {item.title === "Wooden Cottage" ? (
                <button onClick={handleNavigate}>Explore</button>
              ) : (
                <a href="/explore-rooms">Explore</a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Accommodation;
